import { render } from "./TrainClass.vue?vue&type=template&id=1cc19543&scoped=true"
import script from "./TrainClass.vue?vue&type=script&lang=js"
export * from "./TrainClass.vue?vue&type=script&lang=js"

import "./TrainClass.vue?vue&type=style&index=0&id=1cc19543&lang=less&scoped=true"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc19543"]])

export default __exports__